<template>
  <section class="error">
    <img class="error-img" src="@/assets/images/error.png" :alt="String(error?.statusCode)" />
    <a
      ref="errorLink"
      :href="`/craftland/${lang}/`"
      :data-show="mounted"
      class="relative mt-10 cursor-pointer text-lg font-medium text-[#C8CCD3] opacity-0 after:absolute after:left-0 after:top-full after:h-0.5 after:w-full after:bg-[#C8CCD3] after:content-[''] data-[show=true]:opacity-100 max-lg:text-2xl"
      @click="clearError()"
    >
      Back to homepage in <span class="text-primary">{{ countDown }}</span> seconds
    </a>
  </section>
</template>
<script lang="ts" setup>
import type { NuxtError } from '#app'
const props = defineProps({
  error: Object as () => NuxtError
})
const countDown = ref(5)
const mounted = ref(false)
const errorLink = ref<HTMLElement>()
let lang = 'en'
let timer: any
onMounted(() => {
  const errorUrl = window.location.pathname
  lang = errorUrl.split('/')[2] || 'en'
  mounted.value = true
  timer = setInterval(() => {
    countDown.value--
    if (countDown.value <= 1) {
      clearInterval(timer)
      errorLink.value && errorLink.value.click()
    }
  }, 1000)
})
onUnmounted(() => {
  clearInterval(timer)
})
</script>
<style lang="scss" scoped>
.error {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #202227;
  background-size: cover;
  background-image: url('@/assets/images/error-bg-m.jpg');
}
.error-img {
  max-width: 50%;
}
@media not all and (min-width: 1024px) {
  @media screen and (orientation: landscape) {
    .error-img {
      max-width: 32%;
    }
  }
}
@media screen and (min-width: 1024px) {
  .error {
    background-image: url('@/assets/images/error-bg.jpg');
  }
  .error-img {
    max-width: 22.22%;
  }
}
</style>
